import React from 'react';
import styled from '@emotion/styled';

import { COLOR_GREEN } from 'client/components/MarketingPagesShared/styles';
import { useT } from 'client/i18n/hooks/useT';
import { IMAGES_MAP } from './constants';
import { SCREEN_BREAKPOINTS } from '../../constants';
import { HeaderWaveIcon } from '../Icons';
import { HeaderContent, HeaderImage } from './components';

const HeaderSection = styled.section`
  position: relative;
  margin-bottom: 200px;
  background: ${COLOR_GREEN};
  .span-header-wave-icon {
    position: absolute;
    bottom: -1px;
  }
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    margin-bottom: 100px;
  }
`;
const HeaderTopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 70px 24px 24px;
  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    > div:first-child,
    > div:last-child {
      display: none;
    }
  }
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    padding: 40px 0 30px;
  }
`;
const HeaderBottomContainer = styled.div`
  position: relative;
  width: 100%;

  svg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: calc(100% + 2px);
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    height: 200px;
  }
  @media (max-width: 600px) {
    height: 100px;
  }
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    height: 75px;
  }
`;
const HeaderBottomImagesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 990px;
  height: calc(100vw * 0.1306);
  margin: 0 auto;
  padding: 0 24px;
  @media (max-width: 600px) {
    > div:nth-child(2) {
      display: none;
    }
  }
`;

export const Header = () => {
  const t = useT();

  const imagesAlt = {
    headerOne: t(
      'AdsByAnchorScreen.Header.ImageAltOne',
      'Man laughing while listening to podcast on his iPhone',
      'Ads by Anchor page header image alt'
    ),
    headerTwo: t(
      'AdsByAnchorScreen.Header.ImageAltTwo',
      'Two individuals smiling while recording tracks for a podcast',
      'Ads by Anchor page header image alt'
    ),
    headerThree: t(
      'AdsByAnchorScreen.Header.ImageAltThree',
      'Man recording a new track for into a microphone for a podcast',
      'Ads by Anchor page header image alt'
    ),
    headerFour: t(
      'AdsByAnchorScreen.Header.ImageAltFour',
      'Man holding a microphone as he prepares to respond on a podcast',
      'Ads by Anchor page header image alt'
    ),
    headerFive: t(
      'AdsByAnchorScreen.Header.ImageAltFive',
      'Two individuals listening to a podcast and reacting to the content',
      'Ads by Anchor page header image alt'
    ),
  };

  return (
    <HeaderSection>
      <HeaderTopContainer>
        <HeaderImage image={IMAGES_MAP.headerOne} alt={imagesAlt.headerOne} />
        <HeaderContent />
        <HeaderImage image={IMAGES_MAP.headerTwo} alt={imagesAlt.headerTwo} />
      </HeaderTopContainer>
      <HeaderBottomContainer>
        <HeaderBottomImagesContainer>
          <HeaderImage
            image={IMAGES_MAP.headerThree}
            alt={imagesAlt.headerThree}
          />
          <HeaderImage
            image={IMAGES_MAP.headerFour}
            alt={imagesAlt.headerFour}
          />
          <HeaderImage
            image={IMAGES_MAP.headerFive}
            alt={imagesAlt.headerFive}
          />
        </HeaderBottomImagesContainer>
      </HeaderBottomContainer>
      <HeaderWaveIcon aria-hidden="true" />
    </HeaderSection>
  );
};
